import * as React from 'react';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import type { OmitStylesComponentProps } from '../../types';

const hoverCardContentVariants = cva('rocco-hover-card-content', {
    variants: {
        variant: {
            default:
                'z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
            cart: 'z-popover w-100 rounded-md border bg-popover p-4 text-popover-foreground shadow-2xl outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const HoverCardContent = React.forwardRef<
    React.ElementRef<typeof HoverCardPrimitive.Content>,
    OmitStylesComponentProps<typeof HoverCardPrimitive.Content> &
        VariantProps<typeof hoverCardContentVariants>
>(({ align = 'center', sideOffset = 4, variant, ...props }, ref) => (
    // Portal (standard shadcn behaviour) so the content escapes the trigger's
    // stacking context — e.g. the header traps the cart preview at the
    // header's z-index otherwise, letting the header hairline and any modal
    // (z-modal drawer) paint over it regardless of the content's own z.
    <HoverCardPrimitive.Portal>
        <HoverCardPrimitive.Content
            ref={ref}
            align={align}
            sideOffset={sideOffset}
            className={hoverCardContentVariants({ variant })}
            {...props}
        />
    </HoverCardPrimitive.Portal>
));

HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;
